import { fetchPrimaryChat } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type {
  FetchChatResponseT,
  FetchPrimaryChatParams,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from './client';

/**
 * Fetch chat messages for a user's primary conversation.
 */
export async function fetchPrimaryChatByUserId(
  userId: string,
  params?: FetchPrimaryChatParams,
  signal?: AbortSignal
): Promise<FetchChatResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchPrimaryChat(userId, params, config);
  return response.data;
}
